import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {OptionLabelValue} from '../../../../types/internal/OptionLabelValue';
import {useLazyGetTemplateEmailsForInfiniteScrollingQuery} from '../../../../redux/api/templateEmails';
import NEWListWithSearchFilter from '../../../common/filters/NEWListWithSearchFilter';

export const TemplateEmailTitleFilter = ({activeFilters, handleFilterChange}: {
  activeFilters: OptionLabelValue[] | null,
  handleFilterChange: (values: OptionLabelValue[]) => void,
}) => {

  const [
    getTemplateEmail,
    {
      data,
      isLoading,
      isFetching,
      isUninitialized,
      originalArgs,
    },
  ] = useLazyGetTemplateEmailsForInfiniteScrollingQuery();

  const [querySearch, setQuerySearch] = useState<string>('');
  const options: OptionLabelValue[] = useMemo(() => data?.results.map(el => ({
    label: el.title,
    value: el.uuid,
  })) || [], [data?.results]);

  const handleGetNext = useCallback(() => {
    getTemplateEmail({
      ordering: 'title',
      ...!!querySearch && {search_by_name: querySearch},
      page: (originalArgs?.page || 0) + 1,
      page_size: 15,
    });
  }, [getTemplateEmail, originalArgs?.page, querySearch]);

  useEffect(() => {
    getTemplateEmail({
      ordering: 'title',
      ...!!querySearch && {search_by_name: querySearch},
      page: 1,
      page_size: 15,
    });
  }, [getTemplateEmail, querySearch]);

  return (
    <NEWListWithSearchFilter
      getNext={handleGetNext}
      options={options}
      selectedOptions={activeFilters || []}
      setSelectedOptions={handleFilterChange}
      total={data?.count || 0}
      isLoadingOptions={isLoading || isFetching || isUninitialized}
      querySearch={querySearch}
      setQuerySearch={setQuerySearch}
    />
  );
};